import React from "react";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import CustomButton from "../Custom/CustomButton";
import { Menu, MenuItem } from "@mui/material";
import DashboardDateFilter from "./DashboardDateFilter";

const actionButtonSx = {
  textTransform: "none",
  borderRadius: "8px",
  backgroundColor: "#fff",
  color: "#374151",
  border: "1px solid #d1d5db",
  fontWeight: 500,
  fontSize: "0.875rem",
  px: 1.5,
  "&:hover": { backgroundColor: "#f9fafb", borderColor: "#9ca3af" },
};

const DashboardHeader = ({
  title = "Dashboard",
  subtitle,
  departments = [],
  selectedDepartmentId = "all",
  onDepartmentSelect,
  timePeriod = { timeRange: "this_week" },
  onTimePeriodChange,
  teamOptions = [],
  teamView = "my-team",
  onTeamViewChange,
  onExportClick,
}) => {
  const [teamsAnchorEl, setTeamsAnchorEl] = React.useState(null);
  const handleTeamsClick = (event) => setTeamsAnchorEl(event.currentTarget);
  const handleTeamsClose = () => setTeamsAnchorEl(null);
  const handleTeamsSelect = (val) => {
    onTeamViewChange?.(val);
    handleTeamsClose();
  };

  const activeTeamLabel =
    teamOptions.find((o) => o.value === teamView)?.label ?? "Teams";

  return (
    <header className="dashboard-header">
      <div className="dashboard-header-top">
        <div className="dashboard-header-title-block">
          <h1 className="dashboard-header-title">{title}</h1>
          {subtitle ? <p className="dashboard-header-subtitle">{subtitle}</p> : null}
        </div>

        <div className="dashboard-header-actions">
          <DashboardDateFilter
            value={typeof timePeriod === "object" ? timePeriod : { timeRange: timePeriod ?? "this_week" }}
            onChange={onTimePeriodChange}
          />

          {teamOptions.length > 0 && (
            <>
              <CustomButton
                variant="outlined"
                color="inherit"
                size="small"
                fullWidth={false}
                className="dashboard-header-action-btn"
                startIcon={<GroupsOutlinedIcon sx={{ fontSize: 16 }} />}
                endIcon={<KeyboardArrowDownIcon sx={{ fontSize: 18 }} />}
                onClick={handleTeamsClick}
                sx={actionButtonSx}
              >
                {activeTeamLabel}
              </CustomButton>
              <Menu
                anchorEl={teamsAnchorEl}
                open={Boolean(teamsAnchorEl)}
                onClose={handleTeamsClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
                PaperProps={{
                  sx: { minWidth: 180, mt: 0.5, borderRadius: "8px", boxShadow: "0 4px 16px rgba(0,0,0,0.1)" },
                }}
              >
                {teamOptions.map((opt) => (
                  <MenuItem
                    key={opt.value}
                    selected={teamView === opt.value}
                    onClick={() => handleTeamsSelect(opt.value)}
                    sx={{ fontSize: "0.875rem", fontWeight: 500 }}
                  >
                    {opt.label}
                  </MenuItem>
                ))}
              </Menu>
            </>
          )}

          {/* <CustomButton
            variant="outlined"
            color="inherit"
            size="small"
            fullWidth={false}
            className="dashboard-header-action-btn"
            startIcon={<FileDownloadOutlinedIcon sx={{ fontSize: 16 }} />}
            onClick={onExportClick}
            sx={actionButtonSx}
          >
            Export
          </CustomButton> */}
        </div>
      </div>

      {teamView === "hod" && departments.length > 0 ? (
        <div className="dashboard-header-scope">
          <span className="dashboard-header-scope-label">Scope Departments:</span>
          <div className="dashboard-scope-chips" role="group" aria-label="Scope departments">
            {departments.map((dept) => {
              const isActive = dept.id === selectedDepartmentId;
              return (
                <button
                  key={dept.id}
                  type="button"
                  className={`dashboard-scope-chip${isActive ? " dashboard-scope-chip--active" : ""}`}
                  aria-pressed={isActive}
                  onClick={() => onDepartmentSelect?.(dept.id)}
                >
                  {dept.label}
                </button>
              );
            })}
          </div>
        </div>
      ) : null}
    </header>
  );
};

export default DashboardHeader;
